(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/preview/preview.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/preview/preview.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  Payfooter
} = svs.tur.ReactPayfooter;
const {
  BubbleInfo
} = svs.tur.bubbleInfo.components;
const {
  mapProductType
} = svs.ticketgames.ticketMappings.productMappings;
const {
  GiftInfo
} = svs.tickets_giftshop.preview.components;
const {
  Products
} = svs.tickets_giftshop.products;
const {
  TrissBackground,
  SkrapspelBackground
} = svs.components.tur.backgrounds;
const {
  GIFT_ROUTE
} = svs.tickets_giftshop.constants.routes;
const {
  EMAIL,
  PHONE
} = svs.tickets_giftshop.constants.names;
const {
  createJupiterVoucherPaymentObject,
  productsPerAmountFromCart,
  deliveryDateHasChanged
} = svs.tickets_giftshop.functions;
const {
  TRISS,
  SKRAPSPEL,
  DEFAULT
} = svs.tickets_giftshop.constants.branding;
const {
  SET,
  APPEND
} = svs.tickets_giftshop.constants.cart;
const {
  cartClearAction
} = svs.tickets_giftshop.gift.giftform.cart.actions;
const {
  formClearAction
} = svs.tickets_giftshop.gift.giftform.actions;
const {
  getCart
} = svs.tickets_giftshop.gift.giftform.cart.getters;
const Preview = _ref => {
  let {
    history,
    formData,
    cart = [],
    cartSum,
    cartCount,
    onResetShop,
    branding
  } = _ref;
  const balance = svs.tickets_giftshop.hooks.useBalance();
  window.scrollTo(0, 0);
  const isPayDisabled = () => {
    let isValid = true;
    if (formData.receiverType === EMAIL && !formData.email) {
      isValid = false;
    }
    isValid = isValid && !name && !cartCount;
    return isValid;
  };
  React.useEffect(() => {
    if (history.location.search && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.utils.paramHandler.remove({
        key: 'ispay'
      });
      if (cart.length > 0) {
        initPayment();
      }
    }
  }, [history]);
  React.useEffect(() => {
    if (!cart.length) {
      history.push('/');
    }
  }, [cart]);
  const initPayment = () => {
    try {
      const payment = new svs.tur.payment.api.jupiter.vouchers.Pay({
        payableObj: createJupiterVoucherPaymentObject(_objectSpread(_objectSpread({
          cart
        }, formData), {}, {
          price: cartSum
        }))
      });
      payment.initialize(branding);
      payment.on(svs.tur.payment.constants.events.PAYMENT_SUCCESS, () => {
        var _formData$dateSelecto, _formData$dateSelecto2;
        svs.components.analytics.trackEvent({
          category: 'VOUCHER',
          action: 'voucher_date_selector',
          opt_label: ((_formData$dateSelecto = formData.dateSelectorUsed) === null || _formData$dateSelecto === void 0 ? void 0 : _formData$dateSelecto.toLowerCase()) || ((_formData$dateSelecto2 = formData.dateSelector) === null || _formData$dateSelecto2 === void 0 ? void 0 : _formData$dateSelecto2.toLowerCase())
        });
        cart.forEach(_ref2 => {
          var _product$type;
          let {
            product,
            amount
          } = _ref2;
          const productType = mapProductType((_product$type = product.type) === null || _product$type === void 0 ? void 0 : _product$type.split(':')[0]);
          for (let i = 0; i < amount; i++) {
            svs.components.analytics.trackEvent({
              category: 'VOUCHER',
              action: "theme_".concat(productType, "_").concat(product.skinId),
              opt_label: product.skinDescription
            });
          }
        });
        svs.tickets_giftshop.clearLocalStorage();
      });
      payment.on(svs.tur.payment.constants.events.DIALOG_SUCCESS_CONFIRM, () => {
        onResetShop && onResetShop();
        handleChangeClick();
      });
    } catch (error) {
      svs.tickets_giftshop.logger.warn('Payment failed with error:', error);
    }
  };
  const handleChangeClick = e => {
    e && e.preventDefault();
    history && history.push(GIFT_ROUTE);
  };
  const handlePay = e => {
    e && e.preventDefault();
    svs.utils.paramHandler.set({
      key: 'ispay',
      value: true
    });
    initPayment();
  };
  const isTriss = branding === TRISS;
  const isSkrapspel = branding === SKRAPSPEL;
  const isDefault = branding === DEFAULT;
  const payfooterButtonOps = [{
    pay: true,
    onClick: handlePay,
    disabled: isPayDisabled()
  }, {
    secondary: true,
    text: 'Ändra',
    onClick: handleChangeClick
  }];
  let datestring = 'Direkt';
  const iso = dateFns.parseISO("".concat(formData.date, "T").concat(formData.time));
  if (deliveryDateHasChanged({
    date: formData.date,
    time: formData.time,
    currentDate: Date.now()
  })) {
    datestring = "".concat(svs.utils.date.FormatTime('dd MMMM yyyy', iso), " kl ").concat(svs.utils.date.SimpleTime(iso));
  }
  return React.createElement(React.Fragment, null, isTriss && React.createElement(TrissBackground, null), (isSkrapspel || isDefault) && React.createElement(SkrapspelBackground, null), React.createElement("div", {
    className: "tg-preview-bubble-info data-hj-suppress"
  }, React.createElement(BubbleInfo, {
    className: "bubble-info-container",
    header: "".concat(formData.personalGreeting, " ").concat(formData.name, "!")
  }, formData.greeting)), React.createElement(Products, {
    isImageOnly: true,
    products: productsPerAmountFromCart(cart)
  }), React.createElement(GiftInfo, {
    dateString: datestring,
    email: formData.email,
    phone: formData.phone,
    receiverType: formData.receiverType,
    totalProducts: cartCount,
    totalProductSum: cartSum
  }), React.createElement("div", {
    className: "tg-preview-payfooter"
  }, React.createElement(Payfooter, {
    balance: balance,
    buttons: payfooterButtonOps,
    isLegalInfo: true,
    reminderTrackingLabel: "preview ".concat(isTriss ? 'Triss' : 'Skrapspel', " Voucher"),
    sum: cartSum
  })));
};
const mapDispatch = dispatch => ({
  onResetShop: () => {
    dispatch(cartClearAction());
    dispatch(formClearAction());
  }
});
const mapStateToProps = state => {
  const {
    cart,
    count,
    sum
  } = getCart(state);
  return {
    formData: state.giftform,
    cart,
    cartCount: count || 0,
    cartSum: sum || 0,
    branding: state.settings.branding
  };
};
svs.tickets_giftshop.preview.Preview = ReactRedux.connect(mapStateToProps, mapDispatch)(Preview);

 })(window);